import React, {Component} from "react";
import {
    Button,
    FormSection,
    Link,
    SectionBody,
    SectionFooter,
    SectionFooterPrimaryContent,
    SectionFooterSecondaryContent,
    SectionHeader
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import {I18n} from "aws-amplify";
import {Alert, Form} from "react-bootstrap";
import InputGroup from "../../node_modules/react-bootstrap/InputGroup";
import DatePicker from "react-datepicker";
import prefactures from "../Constants/Prefectures";
import * as PropTypes from "prop-types";
import {STYLE_LINK} from "../Styles/style";
import Header from "./parts/Header";
import Footer from "./parts/Footer";
import '../Styles/genelife.css';
import '../Styles/subpages.css';
import ja from "date-fns/locale/ja";
import RakutenConnect from "./parts/RakutenConnect";
import ModalOauthComponent from "./parts/ModalOauthComponent";
import RakutenBackToLogin from "./parts/RakutenBackToLogin";

export class ChangeUserInfoComponents extends Component {
    render() {
        let alert_component = null;
        if (this.props.action_type === 'connect_oauth') {
            alert_component =
                <Alert key={0} variant={'success'}>
                    楽天連携ID連携に成功しました
                </Alert>
        } else if (this.props.action_type === 'unconnect_oauth_only_research_permit') {
            alert_component =
                <Alert key={0} variant={'success'}>
                    研究同意の解除に成功しました
                </Alert>

        } else if (this.props.action_type === 'unconnect_oauth') {
            alert_component =
                <Alert key={0} variant={'success'}>
                    楽天連携ID連携解除に成功しました
                </Alert>

        }
        let dialog_compoent = null;
        if (this.props.open_modal) {
            if (this.props.execute_method === 'backLogin') {
                dialog_compoent =
                    <RakutenBackToLogin show={this.props.open_modal} onHide={this.props.handleClose}
                                        theme={this.props.theme}
                                        onClick={this.props.handleExecuteOauth}
                    />
            } else {
                dialog_compoent =
                    <ModalOauthComponent show={this.props.open_modal} onHide={this.props.handleClose}
                                         modalTitle={this.props.modal_title} theme={this.props.theme}
                                         modalMessage={this.props.modal_message} onClick={this.props.handleExecuteOauth}/>

            }

        }
        return (
            <div>
            <Header authState={this.props.authState}/>
            <div className="container">
            <FormSection theme={this.props.theme} style={{display: "block"}}>
            <SectionHeader theme={this.props.theme}>{I18n.get("ユーザ情報変更")}</SectionHeader>
            {alert_component}
            {dialog_compoent}

            <SectionBody theme={this.props.theme}>
                <Form>
                    <Form.Group controlId="formGroupName">
                        <Form.Label>お名前※</Form.Label>
                        <InputGroup className="mb-4">
                            <Form.Control placeholder="姓:(例)山田"
                                          name="name01"
                                          value={this.props.name01}
                                          onChange={this.props.handleInputChangeSignUp}
                            />
                            <Form.Control placeholder="名:(例)太郎"
                                          name="name02"
                                          value={this.props.name02}
                                          onChange={this.props.handleInputChangeSignUp}
                            />
                        </InputGroup>
                        {this.props.name01_err_msg}
                        {this.props.name02_err_msg}
                    </Form.Group>
                    <Form.Group controlId="formGroupKatakana">
                        <Form.Label>フリガナ※</Form.Label>
                        <InputGroup className="mb-4">
                            <Form.Control placeholder="姓:(例)ヤマダ"
                                          name="kana01"
                                          value={this.props.kana01}
                                          onChange={this.props.handleInputChangeSignUp}
                            />
                            <Form.Control placeholder="名:(例)タロウ"
                                          name="kana02"
                                          value={this.props.kana02}
                                          onChange={this.props.handleInputChangeSignUp}
                            />
                        </InputGroup>
                        {this.props.kana01_err_msg}
                        {this.props.kana02_err_msg}
                        {this.props.kana_err_msg}
                    </Form.Group>
                    <Form.Group controlId="formGroupKatakana">
                        <Form.Label>ニックネーム※</Form.Label>
                        <Form.Control placeholder="姓:(例)ヤマダ"
                                      name="name03"
                                      value={this.props.name03}
                                      onChange={this.props.handleInputChangeSignUp}
                        />
                        {this.props.name03_err_msg}
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>生年月日※</Form.Label>
                        <div>
                            <DatePicker
                                locale={ja}
                                dateFormat="yyyy/MM/dd"
                                name="birth"
                                showYearDropdown
                                showMonthDropdown
                                maxDate={new Date()}
                                selected={this.props.birth}
                                onChange={this.props.handleBirthChange}
                                dropdownMode="select"/>
                        </div>
                        {this.props.birth_err_msg}
                    </Form.Group>

                    <Form.Group className="mb-3">
                        <Form.Label>性別※</Form.Label>
                        <div key={`inline-radio`} className="mb-3">
                            <Form.Check inline label="男" type="radio" id={`inline-radio-1`}
                                        name="men"
                                        value="1"
                                        checked={this.props.menChecked}
                                        onChange={this.props.handleRadioClick}
                            />
                            <Form.Check inline label="女" type="radio" id={`inline-radio-2`}
                                        name="women"
                                        value="2"
                                        checked={this.props.womenChecked}
                                        onChange={this.props.handleRadioClick}
                            />
                        </div>
                    </Form.Group>


                    <Form.Group className="mb-3">
                        <Form.Label>メルマガ配信※</Form.Label>
                        <div key={`inline-radio`} className="mb-3">
                            <Form.Check inline label="希望する" type="radio" id={`inline-radio-3`}
                                        name="mailmaga_demand"
                                        value="2"
                                        checked={this.props.mailmagaDemandChecked}
                                        onChange={this.props.handleRadioMailMagaClick}
                            />
                            <Form.Check inline label="希望しない" type="radio" id={`inline-radio-4`}
                                        name="mailmaga_undemand"
                                        value="3"
                                        checked={this.props.mailmagaUndemandChecked}
                                        onChange={this.props.handleRadioMailMagaClick}
                            />
                        </div>
                    </Form.Group>

                    <Form.Group controlId="formGridZip">
                        <Form.Label>郵便番号※ </Form.Label>
                        <Form.Control placeholder="(例) 150" name="zip" onChange={this.props.handleZipChange}
                                      input type="text" value={this.props.zip} onBlur={this.props.handleOnBlur}/>
                        {this.props.zip_err_msg}
                    </Form.Group>


                    <Form.Group controlId="formGridPrefecture">
                        <Form.Label>都道府県</Form.Label>
                        <Form.Control as="select" value={this.props.pref} onChange={this.props.handleInputChangeSignUp} name="pref">
                            {prefactures.map(this.props.callbackfn
                            )}
                        </Form.Control>
                    </Form.Group>


                    <Form.Group controlId="formGridAddr01">
                        <Form.Label>市町村</Form.Label>
                        <Form.Control placeholder="(例) 東京都渋谷区恵比寿"
                                      name="addr01"
                                      onChange={this.props.handleInputChangeSignUp}
                                      value={this.props.addr01}
                        />
                        {this.props.addr01_err_msg}
                    </Form.Group>


                    <Form.Group controlId="formGridAddr02">
                        <Form.Label>丁目・番地</Form.Label>
                        <Form.Control placeholder="(例) 四丁目20番3号"
                                      name="addr02"
                                      value={this.props.addr02}
                                      onChange={this.props.handleInputChangeSignUp}
                        />
                        {this.props.addr02_err_msg}
                    </Form.Group>


                    <Form.Group controlId="formGridAddr03">
                        <Form.Label>建物名・部屋番号</Form.Label>
                        <Form.Control placeholder="(例) 恵比寿ガーデンプレイスタワー15階"
                                      name="addr03"
                                      value={this.props.addr03}
                                      onChange={this.props.handleInputChangeSignUp}
                        />
                    </Form.Group>

                    <Form.Group controlId="formGridPhnoe">
                        <Form.Label>電話番号※ 半角英数</Form.Label>
                        <Form.Control
                            name="tel"
                            input type="text"
                            value={this.props.tel}
                            onBlur={this.props.handleOnBlur}
                            onChange={this.props.handleInputChangeSignUp}
                        />
                        {this.props.tel_err_msg}
                    </Form.Group>
                </Form>
            </SectionBody>
            <SectionFooter theme={this.props.theme}>
                <SectionFooterPrimaryContent theme={this.props.theme}>
                    <Button onClick={this.props.updateUserInfo} theme={this.props.theme}>
                        {I18n.get("ユーザ情報を更新する")}
                    </Button>
                </SectionFooterPrimaryContent>
                <SectionFooterSecondaryContent theme={this.props.theme}>
                    <Link theme={this.props.theme} style={STYLE_LINK} onClick={this.props.history_back}>
                        {I18n.get("前の画面へ戻る")}
                    </Link>
                </SectionFooterSecondaryContent>
            </SectionFooter>
            </FormSection>
            </div>
            <Footer theme={this.props.theme}/>
            </div>);
    }
}

ChangeUserInfoComponents.propTypes = {
    theme: PropTypes.any,
    authState: PropTypes.string,
    handleInputChangeSignUp: PropTypes.func,
    name01: PropTypes.string,
    name02: PropTypes.string,
    name01_err_msg: PropTypes.any,
    name02_err_msg: PropTypes.any,
    kana01: PropTypes.string,
    kana02: PropTypes.string,
    kana01_err_msg: PropTypes.any,
    kana02_err_msg: PropTypes.any,
    kana_err_msg: PropTypes.any,
    name03: PropTypes.string,
    name03_err_msg: PropTypes.any,
    birth: PropTypes.any,
    handleBirthChange: PropTypes.func,
    birth_err_msg: PropTypes.any,
    menChecked: PropTypes.bool,
    handleRadioClick: PropTypes.func,
    womenChecked: PropTypes.bool,
    mailmagaDemandChecked: PropTypes.bool,
    handleRadioMailMagaClick: PropTypes.func,
    mailmagaUndemandChecked: PropTypes.bool,
    handleZipChange: PropTypes.func,
    zip: PropTypes.string,
    zip_err_msg: PropTypes.any,
    pref: PropTypes.string,
    callbackfn: PropTypes.func,
    addr01: PropTypes.string,
    addr01_err_msg: PropTypes.any,
    addr02: PropTypes.string,
    addr02_err_msg: PropTypes.any,
    addr03: PropTypes.string,
    tel: PropTypes.string,
    tel_err_msg: PropTypes.any,
    updateUserInfo: PropTypes.func,
    handlePutOauth: PropTypes.func,
    handleDeleteOauth: PropTypes.func,
    handleExecuteOauth: PropTypes.func,
    handleClose: PropTypes.func,
    action_type: PropTypes.string,
    open_modal: PropTypes.bool,
    execute_method: PropTypes.string,
    modal_title: PropTypes.string,
    modal_message: PropTypes.string,
    history_back: PropTypes.func,
    handleOnBlur: PropTypes.func,
};
